
import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

import Layout from '../../Layout';
import AdminLayout from '../../components/admin/AdminLayout';

export default function LayoutWrapper({ children }) {
    const location = useLocation();

    // Check if current path matches any standalone layouts (fullscreen, no navbar/sidebar)
    const isHomePage = location.pathname === '/';
    const isAiTrading = location.pathname.startsWith('/ai-trading');
    const isChatPage = location.pathname === '/chat';
    const isAdminSupport = location.pathname === '/admin-support';

    // Trading System: Admin Pages -> Use New Admin Sidebar Layout
    const isTradingAdmin = location.pathname.startsWith('/admin/indicator-alerts') ||
        location.pathname.startsWith('/admin/alerts') ||
        location.pathname.startsWith('/admin/users') ||
        location.pathname.startsWith('/admin/terms') ||
        location.pathname.startsWith('/admin/receiver');

    if (isTradingAdmin) {
        return (
            <AdminLayout>
                {children}
            </AdminLayout>
        );
    }

    // Trading System: User Dashboard -> Use original Full Layout (Floating Menu etc)
    const isTradingDashboard = location.pathname === '/tradingview-alerts';

    if (isTradingDashboard) {
        return (
            <Layout>
                {children}
            </Layout>
        );
    }

    const isStandalone = isHomePage || isAiTrading || isChatPage || isAdminSupport;

    if (isStandalone) {
        // Render without global sidebar/navbar for fullscreen experience
        return (
            <div className="app-standalone">
                {children}
            </div>
        );
    }

    // Default Global Layout
    return (
        <div className="app">
            <Sidebar />
            <Navbar />
            <main className="main-content">
                {children}
            </main>
        </div>
    );
}
